import Helpers from './plugins/helper-methods';

try {
    require('./bootstrap');
    window.Vue = require('vue');
    window.events = new Vue;
    Vue.component('notification', require('./components/Admin/Notification.vue'));
    Vue.component('scheduler-settings', require('./components/Admin/SchedulerSettings'));
    Vue.use(Helpers);
    new Vue({
        el: '#app',
    });
    console.log("Required assets loaded.")
} catch (e) {
    console.error("Failed to load assets.")
}



// WEBPACK FOOTER //
// ./resources/js/app.js